/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { Fieldset as FormFieldset } from '../../apiForm/form';
import { hasRenderedChildren } from '../helper';

export default function Fieldset({
  inputKey,
  translation,
  language,
  children,
}: WrappedFunctionProps) {
  if (!hasRenderedChildren(children)) return null;

  return (
    <FormFieldset
      category={inputKey}
      legend={translation?.title?.[language] || inputKey}
    >
      {children}
    </FormFieldset>
  );
}
